import { createAction } from "@reduxjs/toolkit";

export const bookItemsAction = createAction("model/items/book");
